<div class="app-wrapper" [attr.isAuthPage]="isAuthPage">
  <router-outlet></router-outlet>
  <div class="versions-wrapper">
    @if (isAuthPage && !isWelcomePage) {
<p class="version-text">{{showBothVersions ? 'UI - ' + 'V' + version : 'V' + version}}</p>
}
    @if (isAuthPage && !isWelcomePage && showBothVersions) {
<p class="version-text">{{'API - ' + 'V' + versionFromBack}}</p>
}
  </div>
</div>
<app-notification></app-notification>
